import React from 'react';
import {ReactComponent as Close} from '../../../../assets/icon/close.svg';
import {IconContainer} from './ModalIcon.styled';
import {IModalIconProps} from "./ModalIcon.helper";


export const CloseIcon: React.FC<IModalIconProps> = ({clickHandler}) => {
  return <IconContainer $isCancel={true} onClick={clickHandler}><Close/></IconContainer>;
};
